import { isElement as u } from "../../../utils/dom/index.js";
import { sortNodes as d, getNextIndex as r, getPrevIndex as a } from "./utils.js";
class b {
  descendants = /* @__PURE__ */ new Map();
  register = (e) => {
    if (e != null)
      return u(e) ? this.registerNode(e) : (t) => {
        this.registerNode(t, e);
      };
  };
  unregister = (e) => {
    this.descendants.delete(e);
    const t = d(Array.from(this.descendants.keys()));
    this.assignIndex(t);
  };
  destroy = () => {
    this.descendants.clear();
  };
  assignIndex = (e) => {
    this.descendants.forEach((t) => {
      t.index = e.indexOf(t.node), t.node.dataset.index = t.index.toString();
    });
  };
  count = () => this.descendants.size;
  enabledCount = () => this.enabledValues().length;
  values = () => Array.from(this.descendants.values()).sort((t, n) => t.index - n.index);
  enabledValues = () => this.values().filter((e) => !e.disabled);
  item = (e) => {
    if (this.count() !== 0)
      return this.values()[e];
  };
  enabledItem = (e) => {
    if (this.enabledCount() !== 0)
      return this.enabledValues()[e];
  };
  first = () => this.item(0);
  firstEnabled = () => this.enabledItem(0);
  last = () => this.item(this.descendants.size - 1);
  lastEnabled = () => {
    const e = this.enabledValues().length - 1;
    return this.enabledItem(e);
  };
  indexOf = (e) => e ? this.descendants.get(e)?.index ?? -1 : -1;
  enabledIndexOf = (e) => e == null ? -1 : this.enabledValues().findIndex((t) => t.node.isSameNode(e));
  next = (e, t = !0) => {
    const n = r(e, this.count(), t);
    return this.item(n);
  };
  nextEnabled = (e, t = !0) => {
    const n = this.item(e);
    if (!n)
      return;
    const s = this.enabledIndexOf(n.node), i = r(s, this.enabledCount(), t);
    return this.enabledItem(i);
  };
  prev = (e, t = !0) => {
    const n = a(e, this.count() - 1, t);
    return this.item(n);
  };
  prevEnabled = (e, t = !0) => {
    const n = this.item(e);
    if (!n)
      return;
    const s = this.enabledIndexOf(n.node), i = a(s, this.enabledCount() - 1, t);
    return this.enabledItem(i);
  };
  registerNode = (e, t) => {
    if (!e || this.descendants.has(e))
      return;
    const n = Array.from(this.descendants.keys()).concat(e), s = d(n), i = {
      ...t,
      disabled: t?.disabled ? t.disabled : void 0
    }, l = { node: e, index: -1, ...i };
    this.descendants.set(e, l), this.assignIndex(s);
  };
}
export {
  b as DescendantsManager
};
//# sourceMappingURL=descendant.js.map
